module.exports = __webpack_public_path__ + "assets/img/loading.18b8c1a2.gif";